/**
 * 定数や共通処理の定義
 */
import Vue from "vue";
import Const from "./const";
import Common from "./common";

export default {
  set() {
    Vue.mixin(Const);
    Vue.mixin(Common);
  }
};
